import axios from "axios";

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || "http://localhost:4000";
const BASE_URL = `${BACKEND_URL}/api/v1`;

export const getMotivosAusencia = async (token) => {
  const res = await axios.get(`${BASE_URL}/motivos-ausencia`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};
